import React, { useEffect } from 'react'
import queryString from 'query-string'
import useRouter from 'hooks/useRouter'

export default function RedirectView() {
  const {
    history,
    location: { search },
  } = useRouter()
  const parsed = queryString.parse(search)

  useEffect(() => {
    if (parsed.url) window.location.replace(parsed.url as string)
    else history.goBack()
  }, [])
  return null
}
